import React from "react";
import { format } from "date-fns";
import pt from "date-fns/locale/pt";

export const cpfMask = value => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const cnpjMask = value => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
};

export const cpfCnpjMask = value => {
  if (value.length < 15) {
    return value
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");
  } else {
    return value
      .replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }
};

export const formatDate = (date, type = 1) => {
  if (date) {
    let dateSafariFix = date;
    if (typeof date === "string") {
      if (date.includes("-")) {
        dateSafariFix = date.replace(/-/g, "/");
      }
    }

    let newDate;
    if (typeof dateSafariFix.getMonth === "function") {
      // Already Date Object
      newDate = new Date(dateSafariFix);
    } else if (dateSafariFix.includes(" ")) {
      // Old Sherms Pattern
      newDate = new Date(dateSafariFix);
    } else {
      // Date String
      let splitDate = dateSafariFix.split("T");
      let dateDate = splitDate[0];
      let dateHour = splitDate[1] ? splitDate[1].split(".")[0] : "00:00:00";

      newDate = new Date(`${dateDate} ${dateHour}`);
    }
    if (type === 1) {
      return format(newDate, "dd'/'MM'/'yyyy' 'HH':'mm", { locale: pt });
    } else if (type === 2) {
      return format(newDate, "dd'/'MM'/'yyyy", { locale: pt });
    } else if (type === 3) {
      return format(newDate, "yyyy'-'MM'-'dd'", { locale: pt });
    } else if (type === 4) {
      return format(newDate, "dd 'de' MMMM 'de' yyyy 'às' HH':'mm", {
        locale: pt,
      });
    } else if (type === 5) {
      return format(newDate, "dd'/'MM'/'yyyy' às 'HH':'mm", { locale: pt });
    } else if (type === 6) {
      return format(newDate, "'às 'HH':'mm", { locale: pt });
    } else if (type === 7) {
      return format(newDate, "dd'/'MM'/'yyyy'", { locale: pt });
    } else if (type === 8) {
      return format(newDate, "yyyy", { locale: pt });
    }
  }
};

export const formatPhone = value => {
  let phoneNumbers = String(value).replace(/[^a-zA-Z0-9 ]/g, "");
  phoneNumbers = phoneNumbers.replace(/\D/g, "");
  phoneNumbers = phoneNumbers.replace(/(\d{2})(\d)/, "($1) $2");
  phoneNumbers = phoneNumbers.replace(/(\d)(\d{4})$/, "$1-$2");
  return phoneNumbers;
};

export const formatReal = value => {
  let _value = parseFloat(value || 0).toFixed(2);
  _value = _value.replace(".", ",");
  return `R$ ${_value}`;
};

export const toDigits = (n, digits) => {
  return n.toLocaleString("en-US", {
    minimumIntegerDigits: digits,
    useGrouping: false,
  });
};

export const templateActivity = (template = 1, turma = "", task = "", status = "") => {
  if (template === 1) {
    return `Atividade criada para <b>${turma}</b> como <b>${task}</b>`;
  } else if (template === 2) {
    return `A tarefa <b>${task}</b> foi marcada como <b>${status}</b>.`;
  } else if (template === 3) {
    return `Os dados da turma <b>${turma}</b> foram alterados.`;
  } else if (template === 4) {
    return `A turma <b>${turma}</b> teve negociação iniciada.`;
  } else if (template === 5) {
    return `O status da negociação foi alterado para <b>${statusFunil(status)}</b>.`;
  } else if (template === 6) {
    return `A tarefa <b>${task}</b> foi duplicada.`;
  } else if (template === 7) {
    return `A tarefa <b>${task}</b> foi deletada.`;
  } else if (template === 8) {
    return `A tarefa <b>${task}</b> foi concluída.`;
  }
};

export const telMask = value => {
  return value
    .replace(/\D/g, "")
    .replace(/^(\d{2})(\d)/g, "($1) $2")
    .replace(/(\d)(\d{4})$/, "$1-$2");
};

export const dataMask = value => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d)/, "$1/$2");
};

export const cepMask = value => {
  return value.replace(/\D/g, "").replace(/^(\d{5})(\d)/g, "$1-$2");
};

export const rgMask = value => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{1})\d+?$/, "$1");
};

export const numericMask = value => {
  return value.replace(/\D/g, "");
};

export const statusAttendance = value => {
  if (value === "cancelado") {
    return "Cancelado";
  } else if (value === "urgente") {
    return "Urgente";
  } else if (value === "aguardandoEquipe") {
    return "Aguardando Equipe";
  } else if (value === "aguardandoFormando") {
    return "Aguardando Formando";
  } else if (value === "resolvido") {
    return "Resolvido";
  } else {
    return "Não Classificado";
  }
};
export const statusFunil = value => {
  if (value === 1) {
    return "Primeiro Contato";
  } else if (value === 2) {
    return "Orçamento";
  } else if (value === 3) {
    return "Envio de Proposta";
  } else if (value === 4) {
    return "Fechamento";
  } else {
    return "Não Classificado";
  }
};
export const statusPaymentSlips = (status, due_date) => {
  let _yesterday = new Date();
  _yesterday.setDate(_yesterday.getDate() - 1);

  if (status === "cancelado") {
    return "Cancelado";
  } else if (status === "pago") {
    return "Pago";
  } else if (status === "nao-gerado") {
    return "Em Processamento";
  } else {
    if (_yesterday > due_date) {
      return "Atrasado";
    } else {
      return "A Vencer";
    }
  }
};
export const statusAttendanceShort = value => {
  if (value === "cancelado") {
    return "Cancelado";
  } else if (value === "urgente") {
    return "Urgente";
  } else if (value === "aguardandoEquipe") {
    return "Aguardando";
  } else if (value === "aguardandoFormando") {
    return "Aguardando";
  } else if (value === "resolvido") {
    return "Resolvido";
  } else {
    return "Não Classificado";
  }
};

export const statusSchedule = status => {
  switch (status) {
    case "foreseen":
      return "Previsto";
    case "pending":
      return "Atrasado";
    case "confirmed":
      return "Confirmado";
    default:
    case "concluded":
      return "Concluído";
  }
};

export const maskFunction = (value, type) => {
  if (type === "tel") {
    return telMask(value);
  } else if (type === "cpf") {
    return cpfMask(value);
  } else if (type === "numeric") {
    return numericMask(value);
  } else if (type === "cep") {
    return cepMask(value);
  } else if (type === "rg") {
    return rgMask(value);
  } else if (type === "cnpj") {
    return cnpjMask(value);
  } else if (type === "cpfCnpj") {
    return cpfCnpjMask(value);
  } else if (type === "data") {
    return dataMask(value);
  } else {
    return value;
  }
};

export const getFirstEvent = commercial => {
  let event_dates = commercial.single.map(e => new Date(e.date_event));
  commercial.package.forEach(e => {
    e.event.forEach(ev => {
      ev.categories.main_events === 1 && event_dates.push(new Date(ev.pivot.date_event));
    });
  });
  event_dates.sort(function (a, b) {
    return a > b;
  });

  return event_dates[0];
};

export const getMaxQuota = commercial => {
  if (commercial && commercial.single.length > 0) {
    let today = new Date();
    let last_quota = new Date(commercial.date_end);

    let time_difference = last_quota.getTime() - today.getTime();
    let days_difference = time_difference / (1000 * 3600 * 24) - 30;

    let max_quota = days_difference > 0 ? Math.round(days_difference / 30) : 0;
    return max_quota;
  }
};

export const logBoletos = e => {
  return e.map(e2 => {
    let _msg = "";
    let _by = false;

    if (e2.type === "error") {
      _msg = <p style={{ color: "var(--color-error)" }}>{e2.message_error}</p>;
    } else {
      if (e2.type === "generate") {
        _msg = "Boleto Gerado";
      } else if (e2.type === "create") {
        _msg = "Boleto Criado";
        _by = true;
      } else if (e2.type === "cancel") {
        _msg = "Boleto Cancelado";
        _by = true;
      } else if (e2.type === "update") {
        _msg = "Boleto Atualizado";
        _by = true;
      }
      _msg = (
        <p>
          {_msg} {_by ? `por ${e2?.users?.username || "-"}` : ""}
          {!!e2.reboleto && " (Renegociação de Boleto)"}
        </p>
      );
    }

    return (
      <div className="m-next-2-inv">
        {_msg}
        <p className="small-label">{formatDate(e2.created_at, 4)}</p>
      </div>
    );
  });
};

function convertToCSV(objArray) {
  var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  var str = "";

  for (var i = 0; i < array.length; i++) {
    var line = "";
    for (var index in array[i]) {
      if (line !== "") line += ",";
      line += array[i][index];
    }
    str += line + "\r\n";
  }
  return str;
}

export const downloadReport = (e, name) => {
  let _table_string = JSON.stringify(e);
  let _table_csv = convertToCSV(_table_string);
  let _table_blob = new Blob([_table_csv], { type: "text/csv;charset=utf-8;" });

  let link = document.createElement("a");
  let url = URL.createObjectURL(_table_blob);
  link.setAttribute("href", url);

  link.setAttribute("download", `${name}-${formatDate(new Date(), 3)}.csv`);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const ceil2 = number => {
  return Math.ceil(Number((number * 100).toFixed(4))) / 100;
};
